import React from 'react';

const SiteContext = React.createContext({
  site: null,
  // eslint-disable-next-line no-unused-vars
  setSite: (site) => {},
});

export default SiteContext;
